import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
// import LockIcon from '@mui/icons-material/Lock'; // Keylock icon
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

type FormWrapperProps = {
    title: string;
    subtitle: string;
    children: ReactNode;
};

export function EsResetWrapper({ title, subtitle, children }: FormWrapperProps) {
    const { themeStyle } = useThemeContext();
    const currentTheme = theme[themeStyle];

    return (
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* Icon */}
            {/* <LockIcon sx={{ fontSize: 40, color: currentTheme.highlight, mb: 1 }} /> */}

            {/* Title */}
            <Typography
                variant="h2"
                sx={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 24,
                    fontWeight: 600,
                    lineHeight: '32px',
                    mb: '10px',
                    mt: '8px',
                    color: currentTheme.primary_white,
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                }}>
                {title}
            </Typography>

            {/* Subtitle */}
            <Typography
                sx={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 14,
                    fontWeight: 500,
                    color: currentTheme.form_label,
                    fontFamily: FONT_ENUM.MAIN_REGULAR,
                    pt: 0.5,
                }}>
                {subtitle}
            </Typography>

            {/* Children */}
            {children}
        </Box>
    );
}
